import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntTagComponent} from "./int-tag.component";
import {IntFieldBoxModule} from "../../boxes";

@NgModule({
  imports: [CommonModule, IntFieldBoxModule],
  declarations: [IntTagComponent],
  exports: [IntTagComponent]
})
export class IntTagModule {}
